import { useState } from "react";

import {
  Button,
  FlagPlusSvg,
  PhonePlusSvg,
  ReportProblem,
  RequestCall,
} from "@components/index";

export const FooterDesktop = () => {
  const [showReportProblem, setShowReportProblem] = useState(false);
  const [showRequestCall, setShowRequestCall] = useState(false);

  return (
    <>
      <div className="absolute flex w-full justify-end pr-8">
        <div className="fixed bottom-0 flex gap-x-2">
          <Button
            height="small"
            leftIcon={<FlagPlusSvg />}
            title="Report Problem"
            className="rounded-none rounded-t-lg bg-lightGray text-black-0 hover:bg-secondary-100 hover:text-white-100 hover:opacity-100"
            onClick={() => setShowReportProblem(true)}
          />
          <Button
            height="small"
            leftIcon={<PhonePlusSvg />}
            title="Request a Call"
            className="rounded-none rounded-t-lg bg-lightGray text-black-0 hover:bg-secondary-100 hover:text-white-100 hover:opacity-100"
            onClick={() => setShowRequestCall(true)}
          />
        </div>
      </div>
      <ReportProblem
        show={showReportProblem}
        onClose={() => setShowReportProblem(false)}
      />
      <RequestCall
        show={showRequestCall}
        onClose={() => setShowRequestCall(false)}
      />
    </>
  );
};
